namespace advisorop {

    export class Constants {
        public static get APP() { return "advisorop"; }

        public static get ADVOP_SERVICES() { return "advisorop.services"; }

        public static get ADVOP_FACTORIES() { return "advisorop.factories"; }
    }
    angular.module("advisorop.services", ["ngComponentRouter"]);
    //angular.module("advisorop.factories");

    ///////////////////////////////////////////////////////////////
    //main application module
    var advisorOp = angular.module("advisorop",
        [
            "ngSanitize",
            "ngComponentRouter",
            "dx",
            "ng-fusioncharts",
            "ngAnimate",
            "ngCookies",
            "ui.bootstrap",
            "angular-ladda",
            "advisorop.services",
        ]);

    // cleaning template cache from AngularJs app on reload browser
    advisorOp.run(function ($rootScope, $templateCache, $http) {
        $rootScope.$on('$viewContentLoaded', function () {
            //console.log('Cleaning $templateCache ...');
            $templateCache.removeAll();
        });


        // in seconds - we have to read this configuration after user login
        var sessionLifetime = 0; // 15min = 15*60
        var warnSessionExpiry = 0; // 5min = 5*60
        var checkSessionEvery = 60; // 1min

        //timer for logout user if he is not active
        localStorage.setItem("lastActivity", `${Date.now()}`);
        setInterval(() => {
            // console.log("Checking user activity...");

            var lastActivity = +localStorage.getItem("lastActivity")

            // we did not start recording
            if (!lastActivity) return;

            // check configuration from user
            if (sessionLifetime === 0 && localStorage.getItem("user")) {
                var user = <domains.identity.IUser>angular.fromJson(localStorage.getItem("user"));

                // read configuration
                sessionLifetime = user.sessionLifeTime;
                warnSessionExpiry = user.sessionWarning;
                checkSessionEvery = user.sessionCheckEvery;

                //console.log(`Configuration has been setup: LT: ${sessionLifetime}, warn: ${warnSessionExpiry}`);

            } else if (!localStorage.getItem("user")) {
                sessionLifetime = 0;
                warnSessionExpiry = 0;
            } else if (!sessionLifetime) return;

            var secondsElapsed = (Date.now() - lastActivity) / 1000;

            // we don't check session when user is on login page
            // it has to be here not before 
            if (window.location.href.indexOf("identity/login") > 0) return;

            // we don't check session when user is on meeting page
            // it has to be here not before 
            if (window.location.href.indexOf("meetinghub/meeting/") > 0) return;

            // console.log(`Current route: ${window.location.href} `);

            var timeLeft = Math.floor(sessionLifetime - secondsElapsed);

            // console.log(`Last activity at: ${lastActivity}. User inactive: ${secondsElapsed}sec`);
            if (timeLeft <= 0) { //2mins
                toastr.error(`You are being logged off due to inactivity, please sign in again`);

                // allow user to read a message
                window.setTimeout(() => {
                    window.location.href = "/identity/login";
                    //console.log(">>>>> Logout user...");
                }, 3000);

            } else if (timeLeft <= warnSessionExpiry) { //1min
                console.log(`Session is going to expire soon. ${timeLeft}sec until it expires`);
                toastr.warning(`Your session will expire in ${timeLeft} seconds`);
            } else {
                //console.log(`Session is good. ${timeLeft}sec until it expires`);
            }
        }, checkSessionEvery * 1000);
        {
            $http.defaults.headers.common['RequestVerificationToken'] = angular.element('input[name="__RequestVerificationToken"]').attr('value');
        }

    });

    advisorOp.config(function (laddaProvider) {
        laddaProvider.setOption({
            style: "expand-left",
            spinnerSize: 35,
            spinnerColor: "#ffffff"
        });
    });

    advisorOp.directive('showErrors', function () {
        return {
            restrict: 'A',
            require: "^form",
            link: function (scope, el, attrs, formCtrl) {
                var inputEl = el[0].querySelector("[name]");

                var inputNgEl = angular.element(inputEl);

                var inputName = inputNgEl.attr('name');

                var helpText = angular.element(el[0].querySelector(".error"));

                inputNgEl.bind('blur', function () {
                    //el.toggleClass('error', formCtrl[inputName].$invalid);
                    //console.log("Event onBlur fired for: " + inputName);
                    inputNgEl.toggleClass('error', formCtrl[inputName].$invalid);
                    helpText.toggleClass('hide', formCtrl[inputName].$valid);
                });
            }
        }
    });

    advisorOp.directive('validateInfo', function () {
        //var regex = /^[0-9]/;
        var regex = /^[A-Za-z_-][A-Za-z0-9_-]*$/;
        return {
            restrict: 'A',
            require: "^form",
            link: function (scope, el, attrs, formCtrl) {

                var inputEl = el[0].querySelector("[name]");

                var inputNgEl = angular.element(inputEl);

                var inputName = inputNgEl.attr('name');

                var helpText = angular.element(el[0].querySelector(".errors"));

                inputNgEl.bind('blur', function () {

                    var isMatchRegex = regex.test(inputNgEl.val() as string);

                    if (isMatchRegex) {
                        inputNgEl.removeClass('errors');
                        helpText.toggleClass('hide', formCtrl[inputName].$valid);
                    }

                    if (!isMatchRegex) {
                        inputNgEl.addClass('errors');
                        helpText.toggleClass('hide', formCtrl[inputName].$invalid);
                    }

                    if (inputNgEl.val() == '') {
                        helpText.toggleClass('hide', formCtrl[inputName].$valid);
                    }
                });
            }
        }
    });

    advisorOp.filter("percentage", ['$filter', function ($filter) {
        return function (input, decimals) {
            return $filter('number')(input * 100, decimals) + '%';
        };
    }]);

    advisorOp.filter("utcToLocal", ['$filter', function ($filter) {
        return function (utcDateString, format) {
            if (!utcDateString) {
                return;
            }

            if (utcDateString.indexOf('Z') === -1 && utcDateString.indexOf('+') === -1) {
                utcDateString += 'Z';
            }

            return $filter('date')(utcDateString, format);
        };
    }]);

    advisorOp.directive("numbox", function () {
        let service: ng.IDirective = {};

        service.restrict = 'A';

        service.scope = {
            ngModel: '='
        };

        service.link = function (scope, element, attributes) {
            var el: any = $(element);
            var attr: any = attributes;

            //setTimeout(function () {
            //    el.NumBox(scope.$eval(attr.numbox));
            //}, 0);


            scope.$watch('ngModel', function () {
                //var s: any = scope;
                //console.log('message now: ' + JSON.stringify(s.ngModel));
                //console.log(el);
                setTimeout(function () {
                    el.NumBox(scope.$eval(attr.numbox));
                }, 0);

            }, true);

        };

        return service;
    });

    advisorOp.directive("fileInput", ["$parse", function ($parse) {
        return {
            link: function ($scope, $element, $attrs, $ngModelCtrl) {
                function createFileInput() {
                    var id = "aoGetFile-" + Date.now();
                    var customButton = document.createElement("button");
                    customButton.setAttribute("style", "display:block;width:120px; height:30px;");
                    //customButton.setAttribute("onClick", "document.getElementById('aoGetFile').click()");
                    customButton.setAttribute("onClick", "document.getElementById('" + id + "').click()");
                    customButton.innerText = "Choose File";
                    var fileInput = document.createElement("input");
                    fileInput.setAttribute("style", "display: none");
                    fileInput.type = "file";
                    //fileInput.id = "aoGetFile";
                    fileInput.id = id;
                    fileInput.multiple = true;
                    angular.element(fileInput).on("change", function (event) {
                        $scope.$apply(function () {
                            $parse($attrs.onChange)($scope, { $event: event });
                        })
                        // remove old file input
                        fileInput.remove();
                        customButton.remove();
                        // create a new file input to make sure the onChange event is fired again
                        createFileInput();
                    })
                    $element.append(customButton);
                    $element.append(fileInput);
                }
                createFileInput();
            },
        }
    }]);

    advisorOp.directive("focus", function () {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                attrs.$observe('focus', function (newValue) {
                    if (newValue == 'true') {
                        (element[0] as HTMLElement).focus();
                    }
                });
            }
        }
    });

    advisorOp.filter('notin', function () {
        return function (listin, listout) {
            return listin.filter(function (el) {
                return listout.indexOf(el) == -1;
            })
        }
    });

    advisorOp.config(function ($locationProvider) {
        $locationProvider.html5Mode(true);
    });


    export class AuthInterceptor {

        unauthorizedMessageSeen: boolean = false;

        static $inject = ['$q'];
        constructor(private $q: ng.IQService) {
            //console.log('>>>>> Interceptor [authInterceptor] has been initialised...');
        }

        response = (response) => {
            // console.log(">>>>> Response received...");
            localStorage.setItem("lastActivity", `${Date.now()}`);
            return response;
        };

        responseError = (response) => {
            // console.log("Response error has been intercepted", response);
            // console.log("Config:", response.config);
            if (response.status == 401 && (response.config.url.indexOf("meetinghub/meeting/") == -1)) {
                if (!this.unauthorizedMessageSeen) {
                    //console.log("unauthorizedMessageSeen set to TRUE");
                    this.unauthorizedMessageSeen = true;
                    // in case of login page we will show different message
                    if (response.config.url.indexOf('identity/login') >= 0) {
                        null; // error message is handled inside login page
                    } else {
                        toastr.error(`You are being logged off due to inactivity, please sign in again`);
                        // allow user to read a message
                        window.setTimeout(() => {
                            window.location.href = "/identity/login";
                        }, 3000);
                    }
                }
                // return an empty object ...
                return {
                    transformRequest: [],
                    transformResponse: [],
                    method: response.config.method, // 'GET',
                    url: response.config.url, // 'http://',
                    headers: {
                        Accept: 'application/json, text/plain, */*'
                    },
                    data: {
                        chart: {},
                        err: response
                    }
                }
            }
            return this.$q.reject(response);
        };
    }
    angular.module("advisorop").service('authInterceptor', AuthInterceptor)
        .config(['$httpProvider', function ($httpProvider) {
            $httpProvider.interceptors.push('authInterceptor');
        }]);

    advisorOp.service('preventTemplateCache', function () {
        let version = localStorage.getItem(constants.LS_VERSION);
        if (!version) {
            version = "";
        }
        return {
            'request': function (config) {
                if (config.url.indexOf('spa/') !== -1) {
                    config.url = `${config.url}?v=${version}`;
                    // console.log(`Template file renamed: ${config.url}`);
                }
                return config;
            }
        }
    })
        .config(function ($httpProvider) {
            $httpProvider.interceptors.push('preventTemplateCache');
        });

    advisorOp.value("$routerRootComponent", "advisorOpApp");
}


namespace advisorop.components {

    interface IAdvisorOpAppModel {
    }

    export interface IAdvisorOpAppController extends IAdvisorOpAppModel {
    }

    export class AdvisorOpAppController implements IAdvisorOpAppController {
    }

    class AdvisorOpApp implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public $routeConfig: any;

        constructor() {
            this.bindings = {
            };
            this.controller = AdvisorOpAppController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/advisorop-app.html';

            this.$routeConfig = [
                { path: "/identity/...", component: "identityApp", name: "Account" },
                { path: "/servicer/...", component: "servicerApp", name: "Servicer" },
                { path: "/advisor/...", component: "advisorApp", name: "Advisor" },
                { path: "/investor/...", component: "investorApp", name: "Investor" },
                { path: "/meetinghub/...", component: "meetingHubApp", name: "MeetingHub" },
                { path: "/**", redirectTo: ["Account", "Login"] }
            ];
        }
    }
    angular.module(advisorop.Constants.APP).component("advisorOpApp", new AdvisorOpApp());
}